import { defineStore } from 'pinia'

interface CartItem {
  id: string
  name: string
  price: number
  quantity: number
  categoryId: string
  supplements: Array<{
    id: string
    name: string
    price: number
  }>
}

export const useCateringStore = defineStore('catering', {
  state: () => ({
    cart: [] as CartItem[],
    deliveryFee: 1,
    isDelivery: false,
    isCartOpen: false,
    showAddCoinsDialog: false,
    productQuantities: {} as Record<string, number>
  }),

  actions: {
    initializeQuantities(products: any[]) {
      products.forEach(product => {
        if (product.availability !== 'UNAVAILABLE' && 
            (product.stockQuantity === -1 || product.stockQuantity > 0)) {
          this.productQuantities[product.id] = 1;
        } else {
          this.productQuantities[product.id] = 0;
        }
      });
    },

    addToCart(
      product: { id: string; name: { en: string }; price: number; category: { id: string } }, 
      quantity: number = 1,
      supplements: Array<{ id: string; name: { en: string }; price: number }> = []
    ) {
      const existingItem = this.cart.find(item => 
        item.id === product.id && 
        JSON.stringify(item.supplements) === JSON.stringify(supplements)
      );
      
      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        this.cart.push({
          id: product.id,
          name: product.name.en,
          price: product.price,
          quantity: quantity,
          categoryId: product.category.id,
          supplements: supplements.map(s => ({
            id: s.id,
            name: s.name.en,
            price: s.price
          }))
        });
      }
      
      // Reset quantity to 1 after adding to cart
      this.productQuantities[product.id] = 1;
    },

    resetCart() {
      this.cart = [];
      this.isDelivery = false;
      this.isCartOpen = false;
      this.productQuantities = {};
    }
  },

  persist: true
})
